var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12291_233015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.67851 2.22206L1.32601 12.8271C1.19504 13.0539 1.12574 13.311 1.12501 13.5729C1.12427 13.8349 1.19213 14.0924 1.32183 14.32C1.45154 14.5475 1.63856 14.7371 1.8643 14.8699C2.09003 15.0028 2.34661 15.0742 2.60851 15.0771H15.3135C15.5754 15.0742 15.832 15.0028 16.0577 14.8699C16.2835 14.7371 16.4705 14.5475 16.6002 14.32C16.7299 14.0924 16.7978 13.8349 16.797 13.5729C16.7963 13.311 16.727 13.0539 16.596 12.8271L10.2435 2.22206C10.1098 2.00164 9.92155 1.8194 9.69691 1.69292C9.47227 1.56644 9.21881 1.5 8.96101 1.5C8.70321 1.5 8.44976 1.56644 8.22512 1.69292C8.00047 1.8194 7.81222 2.00164 7.67851 2.22206Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6.07709V9.07709",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12.0771H9.0075",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12291_233015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert_icon.8117ab0796f8f7bc5f4911a0a1fb60d6.svg";
export { ForwardRef as ReactComponent };